/* eslint-disable react/display-name */
import {
  Button,
  IconButton,
  Tooltip,
  Grid,
  Typography,
  CircularProgress,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import RefreshIcon from "@mui/icons-material/Refresh";

import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import InventoryAdjustmentMultipleItem from "./InventoryAdjustmentMultipleItem";
import API from "../../../utils/API";
import { StringUtils } from "../../../utils/StringUtils";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
export default function InventoryAdjustmentDraftList(props) {
  const { t } = useTranslation();
  const translate = t;
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [windowTitle, setWindowTitle] = useState("");
  const [rowLimitPerPage, setRowLimitPerPage] = useState(
    Math.round((getWindowDimensions().height - 155) / 32)
  );

  useEffect(() => {
    setWindowTitle(translate("Inventory Adjustment Draft List"));
    loadData();
  }, []);

  var biRef = {};

  async function loadData() {
    let sort = '[{id:"createdDate",desc:true}]';
    let search = "[]";
    loadByRest(0, rowLimitPerPage, sort, search);
  }

  async function loadByRest(curPage, pageSize, sort, filter) {
    let status = "DRAFT";
    setIsLoading(true);
    const result = await API.get(
      "/api/v1/inventory/adjustment/list/" +
        status +
        "?range=" +
        encodeURIComponent(
          "[" + curPage * pageSize + "," + ((curPage + 1) * pageSize - 1) + "]"
        ) +
        "&filter=" +
        encodeURIComponent(filter) +
        "&sort=" +
        encodeURIComponent(sort)
    );
    var arr = result.headers["content-range"].split("/");
    const opt = { ...option };
    opt.count = parseInt(arr[2]);
    setOption(opt);
    setData(result.data);
    setIsLoading(false);
  }

  async function onTableChange(tableState) {
    let sort = "[]";
    if (tableState.sortOrder.name) {
      sort =
        '[{id:"' +
        tableState.sortOrder.name +
        '",desc:' +
        (tableState.sortOrder.direction === "desc" ? "true}]" : "false}]");
    }
    if (tableState.sortOrder.name) {
      sort =
        '[{id:"' +
        tableState.sortOrder.name +
        '",desc:' +
        (tableState.sortOrder.direction === "desc" ? "true}]" : "false}]");
    }
    let search = "[]";
    if (tableState.searchText) {
      let str = "[";
      str = str + '{id:"orderId",value:"' + tableState.searchText + '"}';
      str = str + ',{id:"description",value:"' + tableState.searchText + '"}';
      str =
        str +
        ',{id:"stockChangeTypeString",value:"' +
        tableState.searchText +
        '"}';

      str = str + "]";
      search = str;
    }
    loadByRest(tableState.page, rowLimitPerPage, sort, search);
  }

  const options = {
    download: false,
    serverSide: true,
    searchable: false,
    viewColumns: false,
    filter: false,
    filterType: "dropdown",
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    tableBodyMaxHeight: "100%",
    tableBodyHeight: getWindowDimensions().height - 155,
    rowsPerPage: Math.round((getWindowDimensions().height - 155) / 32),
    rowsPerPageOptions: [
      Math.round((getWindowDimensions().height - 155) / 32),
      10,
      15,
      50,
      100,
    ],
    print: false,
    onTableChange: (action, tableState) => {
      // a developer could react to change on an action basis or
      // examine the state as a whole and do whatever they want

      switch (action) {
        case "changePage":
          onTableChange(tableState);
          break;
        case "sort":
          onTableChange(tableState);
          break;
        case "changeRowsPerPage":
          onTableChange(tableState);
          break;
        case "search":
          onTableChange(tableState);
          break;
        case "filterChange":
          onTableChange(tableState);
          break;
        default:
        //console.log("action not handled." + action);
      }
    },
    customToolbar: () => {
      return (
        <React.Fragment>
          <Tooltip title={translate("Refresh Data")}>
            <IconButton
              size="small"
              color="primary"
              onClick={handleListRefresh}
            >
              <RefreshIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      );
    },
  };

  function onEditClicked(row, updateValue, value, type) {
    biRef.multipleItemAdjustment.showInventoryAdjustmentMultipleItem(
      row.tableData[row.rowIndex].id
    );
  }
  const [option, setOption] = useState(options);
  const columns = [
    {
      name: "orderId",
      label: translate("Order Id"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "createdDate",
      label: translate("Date"),
      options: {
        filter: false,
        sort: true,
        setCellHeaderProps: () => ({
          align: "left",
          "@media only screen and (max-width: 600px)": {},
        }),
        setCellProps: () => ({ align: "left" }),
        customBodyRender: (value, tableMeta, updateValue) => {
          return StringUtils.formatDate(new Date(value), 1);
        },
      },
    },
    {
      name: "stockChangeTypeString",
      label: translate("Stock Change Type"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "description",
      label: translate("Description"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "action",
      label: translate("Actions"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        setCellHeaderProps: () => ({
          align: "right",
        }),
        setCellProps: () => ({ align: "right" }),
        customBodyRender: (value, tableMeta, updateValue) => (
          <Button
            onClick={() => onEditClicked(tableMeta, updateValue, value)}
            color="secondary"
            style={{
              margin: 0,
              padding: 0,
              height: 17,
              width: 27,
              alignText: "right",
            }}
          >
            {translate("Edit")}
          </Button>
        ),
      },
    },
  ];

  function handleListRefresh() {
    loadData();
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <div>
          <MUIDataTable
            title={
              <Typography variant="h6">
                {windowTitle}
                {isLoading && (
                  <CircularProgress
                    size={24}
                    style={{ marginLeft: 15, position: "relative", top: 4 }}
                  />
                )}
              </Typography>
            }
            data={data}
            columns={columns}
            options={option}
          />
        </div>
      </Grid>
      <InventoryAdjustmentMultipleItem
        biRef={biRef}
        onRefreshList={loadData}
        showMessage={props.showMessage}
        setAlert={props.setAlert}
        context={props.context}
        productCache={props.productCache}
      ></InventoryAdjustmentMultipleItem>
    </Grid>
  );
}
